import { RETURN_TO_PARAM } from '@hub/router/relativePath';

/** Which keys the journey retains is login's; the key and its safety check are `@hub/router/relativePath`'s. */
export const RETURN_TO_KEYS = [RETURN_TO_PARAM] as const;
